<template>
  <nav class="main-links">
    <h6>Timelines</h6>
    <ul>
      <li><router-link to="/timeline">Industry Timeline</router-link></li>
      <li><router-link to="/synchromed-timeline">SynchroMed II Timeline</router-link></li>
      <li><router-link to="/asr-timeline">ASR Timeline</router-link></li>
      <li><router-link to="/tavi-timeline">CoreValve (TAVI) Timeline</router-link></li>
    </ul>
    <h6>Overview graphics</h6>
    <ul>
      <li><router-link to="/healthcare-industry-chart">S&amp;P Healthcare vs. S&amp;P Global</router-link></li>
      <li><router-link to="/adverse-events">FDA adverse events - deaths and injuries</router-link></li>
      <li><router-link to="/breast-implants-stacked-chart">Breast implants underreporting</router-link></li>
      <li><router-link to="/deaths-underreporting">Underreporting of deaths</router-link></li>
      <li><router-link to="/industry-lobbying">Medical device industry lobbying</router-link></li>
      <li><router-link to="/doctor-payments">Payments to doctors, by company, 2017</router-link></li>
      <li><router-link to="/pma-wait-times">FDA PMA approval processing time, 1996 to 2018</router-link></li>
      <li><router-link to="/device-related-incidents-in-europe">Reports of suspected device-related incidents increasing across Europe</router-link></li>
      <li><router-link to="/reports-of-problems-involving-medical-devices-since-2008-in-uk">Reports of problems involving medical devices since 2008 in UK</router-link></li>
      <li><router-link to="/norwegian-reports">Results of investigations into Norwegian adverse incident reports</router-link></li>
    </ul>
    <h6>Medtronic graphics</h6>
    <ul>
      <li><router-link to="/medtronic-lobbying">Medtronic lobbying</router-link></li>
      <li><router-link to="/company-adverse-events">Adverse events by company</router-link></li>
      <li><router-link to="/medtronic-doctor-payments">Medtronic's payments to doctors</router-link></li>
    </ul>
    <h6>Other</h6>
    <ul>
      <li><router-link to="/breast-implant-warnings">Breast implant survey results</router-link></li>
    </ul>
  </nav>
</template>

<style scoped lang="scss">
  .main-links {
    border-bottom: 1px solid $card-border-color;
    padding: 20px;
    ul {
      padding-left: 10px;
    }
    li {
      list-style-type: none;
    }
  }
</style>

<script>
  export default {
    name: 'MainLinks'
  }
</script>
